<template>
  <div>
    <el-card shadow="hover">
      <template slot="header">
        <div class="clearfix">
          <span>个人待办</span>
          <div style="float: right">
            <el-button type="primary" size="small" @click="openDialog()">新增任务</el-button>
          </div>
        </div>
      </template>
      <el-form :inline="true" :model="searchForm" class="mb-4">
        <el-form-item label="关键词">
          <el-input v-model="searchForm.keyword" placeholder="标题/内容模糊匹配" style="width: 240px" clearable @keyup.enter.native="handleSearch" @clear="handleSearch"></el-input>
        </el-form-item>
        <el-form-item label="优先级">
          <el-select v-model="searchForm.priority" clearable placeholder="全部" style="width: 120px">
            <el-option label="高" value="高"></el-option>
            <el-option label="中" value="中"></el-option>
            <el-option label="低" value="低"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleSearch">搜索</el-button>
          <el-button @click="resetSearch">重置</el-button>
        </el-form-item>
      </el-form>

      <el-table :data="taskList" stripe v-loading="loading"
                row-key="id" :expand-row-keys="expandRowKeys"
                @row-dblclick="row => openDialog(row)">
        <!-- 仅系统代办（id<0）才展开；普通代办展开区为空，el-table 默认会显示展开图标，我们用 v-if 让正文为空时不显示也行；
             折中方案：始终保留展开列，普通代办展开区显示"无详情" -->
        <el-table-column type="expand" width="48">
          <template slot-scope="scope">
            <div v-if="scope.row.systemType === 'newout-uncompleted'" class="task-expand-panel">
              <div class="task-expand-title">
                <i class="el-icon-warning"></i>
                <span>未完结的新出库单</span>
              </div>
              <el-table :data="pagedDetails(scope.row)" size="mini" border class="task-expand-table task-expand-clickable" :row-class-name="rowHitClass" @row-click="r => goDetail(scope.row.systemType, r)">
                <el-table-column label="出库日期" width="120" align="center">
                  <template slot-scope="s">{{ s.row.finishTime ? String(s.row.finishTime).replace('T',' ').slice(0,10) : '-' }}</template>
                </el-table-column>
                <el-table-column prop="customerName" label="客户姓名" min-width="120" align="center"></el-table-column>
                <el-table-column prop="productNames" label="产品名称" min-width="260" show-overflow-tooltip align="center"></el-table-column>
                <el-table-column prop="totalQuantity" label="数量" width="80" align="center"></el-table-column>
                <el-table-column prop="userName" label="经办人" width="120" align="center"></el-table-column>
              </el-table>
              <div class="expand-pager">
                <el-pagination small layout="prev, pager, next, total" :total="(scope.row.details || []).length"
                               :page-size="expandPageSize" :current-page="expandPageMap[scope.row.id] || 1"
                               @current-change="p => onExpandPage(scope.row, p)" />
              </div>
            </div>
            <div v-else-if="scope.row.systemType === 'low-stock'" class="task-expand-panel">
              <div class="task-expand-title">
                <i class="el-icon-box"></i>
                <span>库存低于阈值的产品</span>
              </div>
              <el-table :data="pagedDetails(scope.row)" size="mini" border class="task-expand-table task-expand-clickable" :row-class-name="rowHitClass" @row-click="r => goDetail(scope.row.systemType, r)">
                <el-table-column prop="productName" label="产品名称" min-width="240"></el-table-column>
                <el-table-column label="当前库存" width="140" align="right">
                  <template slot-scope="s"><span class="stock-val">{{ s.row.stock }}</span></template>
                </el-table-column>
                <el-table-column prop="threshold" label="提醒阈值" width="140" align="right"></el-table-column>
              </el-table>
              <div class="expand-pager">
                <el-pagination small layout="prev, pager, next, total" :total="(scope.row.details || []).length"
                               :page-size="expandPageSize" :current-page="expandPageMap[scope.row.id] || 1"
                               @current-change="p => onExpandPage(scope.row, p)" />
              </div>
            </div>
            <div v-else-if="scope.row.systemType === 'admin-pending-approval'" class="task-expand-panel">
              <div class="task-expand-title">
                <i class="el-icon-finished"></i>
                <span>自己客户的待审核提货申请</span>
              </div>
              <el-table :data="pagedDetails(scope.row)" size="mini" border class="task-expand-table task-expand-clickable" :row-class-name="rowHitClass" @row-click="r => goDetail(scope.row.systemType, r)">
                <el-table-column prop="customerName" label="客户姓名" min-width="140"></el-table-column>
                <el-table-column prop="outboundType" label="出库类型" width="120"></el-table-column>
                <el-table-column prop="productNames" label="商品" min-width="240" show-overflow-tooltip></el-table-column>
                <el-table-column label="申请时间" width="120">
                  <template slot-scope="s">{{ s.row.createTime ? String(s.row.createTime).slice(0,10) : '-' }}</template>
                </el-table-column>
              </el-table>
              <div class="expand-pager">
                <el-pagination small layout="prev, pager, next, total" :total="(scope.row.details || []).length"
                               :page-size="expandPageSize" :current-page="expandPageMap[scope.row.id] || 1"
                               @current-change="p => onExpandPage(scope.row, p)" />
              </div>
            </div>
            <div v-else-if="scope.row.systemType === 'manufacturer-expiry'" class="task-expand-panel">
              <div class="task-expand-title">
                <i class="el-icon-time"></i>
                <span>厂家资料临期 / 已过期清单</span>
              </div>
              <el-table :data="pagedDetails(scope.row)" size="mini" border class="task-expand-table task-expand-clickable" :row-class-name="rowHitClass" @row-click="r => goDetail(scope.row.systemType, r)">
                <el-table-column prop="manufacturerName" label="厂家" min-width="180"></el-table-column>
                <el-table-column prop="docType" label="资料类型" width="120"></el-table-column>
                <el-table-column label="到期日" width="120">
                  <template slot-scope="s">{{ s.row.expiryDate ? String(s.row.expiryDate).slice(0,10) : '-' }}</template>
                </el-table-column>
                <el-table-column label="状态" width="160">
                  <template slot-scope="s">
                    <el-tag v-if="Number(s.row.daysLeft) < 0" type="danger" size="mini">已过期 {{ Math.abs(Number(s.row.daysLeft)) }} 天</el-tag>
                    <el-tag v-else-if="Number(s.row.daysLeft) === 0" type="danger" size="mini">今日到期</el-tag>
                    <el-tag v-else-if="Number(s.row.daysLeft) <= 7" type="warning" size="mini">{{ s.row.daysLeft }} 天后到期</el-tag>
                    <el-tag v-else type="info" size="mini">{{ s.row.daysLeft }} 天后到期</el-tag>
                  </template>
                </el-table-column>
              </el-table>
              <div class="expand-pager">
                <el-pagination small layout="prev, pager, next, total" :total="(scope.row.details || []).length"
                               :page-size="expandPageSize" :current-page="expandPageMap[scope.row.id] || 1"
                               @current-change="p => onExpandPage(scope.row, p)" />
              </div>
            </div>
            <div v-else-if="scope.row.systemType === 'restock-arrival'" class="task-expand-panel">
              <div class="task-expand-title">
                <i class="el-icon-download"></i>
                <span>最近到货入库流水</span>
              </div>
              <el-table :data="pagedDetails(scope.row)" size="mini" border class="task-expand-table task-expand-clickable" :row-class-name="rowHitClass" @row-click="r => goDetail(scope.row.systemType, r)">
                <el-table-column prop="productName" label="产品名称" min-width="200"></el-table-column>
                <el-table-column label="数量" width="100" align="right">
                  <template slot-scope="s">
                    <span :style="Number(s.row.quantity) >= 0 ? 'color:#67c23a;font-weight:700' : 'color:#f56c6c;font-weight:700'">{{ Number(s.row.quantity) > 0 ? '+' : '' }}{{ s.row.quantity }}</span>
                  </template>
                </el-table-column>
                <el-table-column prop="batchNo" label="生产批次" min-width="140" show-overflow-tooltip>
                  <template slot-scope="s">{{ s.row.batchNo || '-' }}</template>
                </el-table-column>
                <el-table-column prop="receiver" label="接货人" width="100">
                  <template slot-scope="s">{{ s.row.receiver || '-' }}</template>
                </el-table-column>
                <el-table-column label="入库时间" width="120">
                  <template slot-scope="s">{{ s.row.createTime ? String(s.row.createTime).slice(0,10) : '-' }}</template>
                </el-table-column>
              </el-table>
              <div class="expand-pager">
                <el-pagination small layout="prev, pager, next, total" :total="(scope.row.details || []).length"
                               :page-size="expandPageSize" :current-page="expandPageMap[scope.row.id] || 1"
                               @current-change="p => onExpandPage(scope.row, p)" />
              </div>
            </div>
            <div v-else class="task-expand-empty">该代办无展开详情</div>
          </template>
        </el-table-column>
        <el-table-column label="标题" min-width="220">
          <template slot-scope="scope">
            <span>{{ scope.row.title }}</span>
            <span v-if="scope.row.details && scope.row.details.length" class="badge-count" style="margin-left:8px">
              {{ scope.row.details.length }} {{ badgeUnit(scope.row.systemType) }}
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="content" label="内容" min-width="260">
          <template slot-scope="scope">
            <div class="task-content-full">{{ scope.row.content }}</div>
          </template>
        </el-table-column>
        <el-table-column label="优先级" width="80">
          <template slot-scope="scope">
            <el-tag :type="priorityType(scope.row.priority)" size="mini">{{ scope.row.priority }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="dueDate" label="截止日期" width="120"></el-table-column>
        <el-table-column label="状态" width="100">
          <template slot-scope="scope">
            <el-tag :type="scope.row.status === 1 ? 'success' : 'warning'" size="mini">
              {{ scope.row.status === 1 ? '已完成' : '待办' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="id" label="ID" width="60"></el-table-column>
        <el-table-column label="操作" width="240" align="center" fixed="right">
          <template slot-scope="scope">
            <span v-if="scope.row.id < 0" class="muted small" style="color:#909399;font-size:12px;">系统代办</span>
            <template v-else>
              <!-- 签字相关任务：只显示删除按钮 -->
              <template v-if="isSignTask(scope.row)">
                <el-button type="danger" size="mini" @click="handleDelete(scope.row.id)">删除</el-button>
              </template>
              <!-- 普通任务：显示完成、修改、删除 -->
              <template v-else>
                <el-button v-if="scope.row.status !== 1" type="success" size="mini" @click="finishTask(scope.row.id)">完成</el-button>
                <el-button type="primary" size="mini" @click="openDialog(scope.row)">修改</el-button>
                <el-button type="danger" size="mini" @click="handleDelete(scope.row.id)">删除</el-button>
              </template>
            </template>
          </template>
        </el-table-column>
      </el-table>

      <div class="mt-4">
        <el-pagination
          @size-change="s => { pageSize = s; getTaskList() }"
          @current-change="p => { currentPage = p; getTaskList() }"
          :current-page="currentPage"
          :page-sizes="[10, 20, 50]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next"
          :total="total">
        </el-pagination>
      </div>
    </el-card>

    <el-dialog :title="form.id ? '编辑任务' : '新增任务'" :visible.sync="dialogVisible" width="880px" :close-on-click-modal="false" :close-on-press-escape="false">
      <el-form :model="form" :rules="rules" ref="form" label-width="100px">
        <el-form-item label="所属用户" prop="userId">
          <el-select v-model="form.userId" filterable style="width: 100%">
            <el-option v-for="u in userList" :key="u.id" :label="(u.name || u.username) + ' (' + u.username + ')'" :value="u.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="标题" prop="title">
          <el-input v-model="form.title" maxlength="100"></el-input>
        </el-form-item>
        <el-form-item label="内容">
          <el-input v-model="form.content" type="textarea" :rows="3" maxlength="500"></el-input>
        </el-form-item>
        <el-form-item label="优先级" prop="priority">
          <el-radio-group v-model="form.priority">
            <el-radio label="高">高</el-radio>
            <el-radio label="中">中</el-radio>
            <el-radio label="低">低</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="截止日期">
          <el-date-picker v-model="form.dueDate" type="date" value-format="yyyy-MM-dd" style="width: 100%"></el-date-picker>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="handleSubmit">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { taskApi, userApi } from '../api/api'

export default {
  data() {
    return {
      taskList: [],
      userList: [],
      searchForm: { userId: null, keyword: '', priority: '' },
      // 展开里的分页：每行 row.id 独立维护当前页；客户姓名命中搜索时自动展开并切到该页
      expandPageMap: {},
      expandPageSize: 5,
      expandRowKeys: [],
      currentPage: 1,
      pageSize: 10,
      total: 0,
      loading: false,
      dialogVisible: false,
      form: {},
      rules: {
        userId: [{ required: true, message: '请选择用户', trigger: 'change' }],
        title: [{ required: true, message: '请输入标题', trigger: 'blur' }],
        priority: [{ required: true, message: '请选择优先级', trigger: 'change' }]
      }
    }
  },
  mounted() {
    this.loadUsers().then(() => {
      // 默认按当前登录用户筛选
      const me = JSON.parse(sessionStorage.getItem('user') || '{}')
      if (me && me.id) {
        this.searchForm.userId = me.id
      } else if (this.userList.length) {
        this.searchForm.userId = this.userList[0].id
      }
      this.getTaskList()
    })
  },
  methods: {
    loadUsers() {
      return userApi.getUserList().then(res => {
        this.userList = res.data || []
      })
    },
    getTaskList() {
      if (!this.searchForm.userId) {
        this.taskList = []
        this.total = 0
        return
      }
      this.loading = true
      taskApi.getTaskPage(this.searchForm.userId, this.currentPage, this.pageSize, {
        priority: this.searchForm.priority || undefined
      }).then(res => {
        let records = res.data.records || []
        // 先隐藏「产品到货入库提醒」(systemType='restock-arrival')
        records = records.filter(r => r.systemType !== 'restock-arrival')
        // 业务员：过滤掉已移除的消息
        const me = JSON.parse(sessionStorage.getItem('user') || '{}')
        if (me && Number(me.roleId) === 3) {
          const dismissed = JSON.parse(localStorage.getItem('dismissed_tasks_' + (me.id || 0)) || '[]')
          if (dismissed.length) records = records.filter(r => !dismissed.includes(r.id))
        }
        // 关键词前端过滤：标题/内容/details 任意字段命中都算（系统代办也参与）
        const kw = (this.searchForm.keyword || '').trim().toLowerCase()
        const expandedIds = []
        if (kw) {
          records = records.filter(r => {
            const titleHit = (r.title || '').toLowerCase().indexOf(kw) !== -1
            const contentHit = (r.content || '').toLowerCase().indexOf(kw) !== -1
            const details = Array.isArray(r.details) ? r.details : []
            const hitIdx = details.findIndex(d => this._detailHit(d, kw))
            const detailHit = hitIdx >= 0
            if (detailHit) {
              // 任务自动展开 + 翻到命中条目所在页
              const targetPage = Math.floor(hitIdx / this.expandPageSize) + 1
              this.$set(this.expandPageMap, r.id, targetPage)
              expandedIds.push(r.id)
            }
            return titleHit || contentHit || detailHit
          })
        }
        this.taskList = records
        this.expandRowKeys = expandedIds   // 详情命中：自动展开
        this.total = res.data.total || 0
        this.loading = false
      }).catch(() => { this.loading = false })
    },
    handleSearch() {
      this.currentPage = 1
      this.getTaskList()
    },
    resetSearch() {
      // 用户 ID 保留（按当前登录账号）
      this.searchForm.keyword = ''
      this.searchForm.priority = ''
      this.expandRowKeys = []
      this.expandPageMap = {}
      this.currentPage = 1
      this.getTaskList()
    },
    priorityType(p) {
      if (p === '高') return 'danger'
      if (p === '中') return 'warning'
      return 'info'
    },
    badgeUnit(t) {
      if (t === 'restock-arrival') return '笔'
      if (t === 'low-stock') return '个'
      if (t === 'admin-pending-approval') return '单'
      if (t === 'manufacturer-expiry') return '项'
      return '条'
    },
    /** 展开里的分页切片 */
    pagedDetails(row) {
      const all = row.details || []
      const page = this.expandPageMap[row.id] || 1
      const size = this.expandPageSize
      return all.slice((page - 1) * size, page * size)
    },
    onExpandPage(row, page) {
      this.$set(this.expandPageMap, row.id, page)
    },
    /** 点击 expand 表里的某行 → 跳转到对应业务模块 */
    goDetail(systemType, row) {
      if (!row) return
      if (systemType === 'newout-uncompleted') {
        if (row.customerId) this.$router.push({ path: '/customer/' + row.customerId, query: { anchor: 'outbound', outboundStatus: 'uncompleted' } })
      } else if (systemType === 'admin-pending-approval') {
        if (row.customerId) this.$router.push({ path: '/customer/' + row.customerId, query: { anchor: 'approval' } })
      } else if (systemType === 'low-stock' || systemType === 'restock-arrival') {
        if (row.productName) this.$router.push({ path: '/stock', query: { keyword: row.productName } })
      } else if (systemType === 'manufacturer-expiry') {
        if (row.manufacturerName) this.$router.push({ path: '/manufacturer', query: { keyword: row.manufacturerName } })
      }
    },
    /** detail 任意字段命中关键词 */
    _detailHit(d, kw) {
      if (!d || !kw) return false
      for (const k in d) {
        const v = d[k]
        if (v == null || typeof v === 'object') continue
        if (String(v).toLowerCase().indexOf(kw) !== -1) return true
      }
      return false
    },
    /** 命中关键词的子表行 → 黄色高亮 */
    rowHitClass({ row }) {
      const kw = (this.searchForm.keyword || '').trim().toLowerCase()
      if (!kw) return ''
      return this._detailHit(row, kw) ? 'row-hit-search' : ''
    },
    openDialog(row) {
      // 系统代办（虚拟，id<0）不可编辑
      if (row && row.id < 0) return
      if (row) {
        this.form = { ...row }
      } else {
        this.form = { userId: this.searchForm.userId, priority: '中' }
      }
      this.dialogVisible = true
    },
    handleSubmit() {
      this.$refs.form.validate((valid) => {
        if (!valid) return
        const action = this.form.id ? taskApi.updateTask(this.form) : taskApi.addTask(this.form)
        action.then(res => {
          if (res.data && res.data.success !== false) {
            this.$message.success(this.form.id ? '更新成功' : '新增成功')
            this.dialogVisible = false
            this.getTaskList()
          }
        })
      })
    },
    finishTask(id) {
      taskApi.finishTask(id).then(res => {
        if (res.data && res.data.success !== false) {
          this.$message.success('已标记完成')
          this.getTaskList()
        }
      })
    },
    handleDelete(id) {
      this.$confirm('仅从待办列表移除该条消息，不影响底层任务数据。', '移除待办', { type: 'info' }).then(() => {
        const me = JSON.parse(sessionStorage.getItem('user') || '{}')
        const key = 'dismissed_tasks_' + (me.id || 0)
        const dismissed = JSON.parse(localStorage.getItem(key) || '[]')
        if (!dismissed.includes(id)) dismissed.push(id)
        localStorage.setItem(key, JSON.stringify(dismissed))
        this.taskList = this.taskList.filter(t => t.id !== id)
        this.total = Math.max(0, this.total - 1)
        this.$message.success('已移除')
      }).catch(() => {})
    },
    /** 判断是否为签字相关任务（业务员的签字待办：隐藏完成和修改按钮） */
    isSignTask(row) {
      if (!row) return false
      const title = (row.title || '').toLowerCase()
      const content = (row.content || '').toLowerCase()
      return title.indexOf('签字') !== -1 || title.indexOf('待签') !== -1 ||
             content.indexOf('签字') !== -1 || content.indexOf('待签') !== -1
    }
  }
}
</script>

<style scoped>
.mb-4 { margin-bottom: 16px; }
.mt-4 { margin-top: 16px; }
.task-content-full {
  white-space: pre-wrap;
  word-break: break-all;
  line-height: 1.5;
}

/* 展开行容器：浅灰底 + 左侧色条，与主表错开层次 */
.task-expand-panel {
  padding: 14px 24px 16px;
  background: linear-gradient(180deg, #fafbfc 0%, #f5f7fa 100%);
  border-left: 3px solid #409EFF;
  border-radius: 0 6px 6px 0;
  margin: 4px 8px 8px 8px;
}
.task-expand-title {
  display: flex;
  align-items: center;
  font-size: 14px;
  font-weight: 600;
  color: #303133;
  margin-bottom: 10px;
}
.task-expand-title i {
  font-size: 16px;
  margin-right: 6px;
  color: #E62412;
}
.expand-pager { padding: 8px 0 4px; text-align: right; }
.task-expand-table ::v-deep tr.row-hit-search > td {
  background: #fff7d6 !important;
  color: #e6a23c !important;
  font-weight: 700 !important;
}
.task-expand-table ::v-deep tr.row-hit-search > td:first-child {
  box-shadow: inset 4px 0 0 0 #f56c6c;
}
.badge-count {
  display: inline-block;
  background: linear-gradient(135deg, #f56c6c 0%, #e6433a 100%);
  color: #fff;
  border-radius: 10px;
  padding: 2px 10px;
  font-size: 12px;
  line-height: 18px;
  font-weight: 700;
  letter-spacing: 1px;
  box-shadow: 0 2px 6px rgba(245, 108, 108, 0.35);
  vertical-align: 1px;
}
.task-expand-title .badge-count {
  margin-left: 10px;
  background: #f56c6c;
  color: #fff;
  border-radius: 10px;
  padding: 2px 10px;
  font-size: 12px;
  line-height: 18px;
  font-weight: 600;
  letter-spacing: 0.5px;
}
.task-expand-empty {
  padding: 14px 24px;
  color: #909399;
  font-size: 12px;
  background: #fafbfc;
  border-left: 3px solid #d3d3d3;
  margin: 4px 8px 8px 8px;
  border-radius: 0 6px 6px 0;
}
/* 内嵌表格：列头浅灰、圆角、行 hover 弱化 */
::v-deep .task-expand-table {
  border-radius: 4px;
  overflow: hidden;
}
::v-deep .task-expand-table thead th {
  background: #f5f7fa !important;
  color: #606266 !important;
  font-weight: 600;
}
::v-deep .task-expand-table .el-table__row:hover > td {
  background: #fafafa !important;
}
::v-deep .task-expand-clickable .el-table__row { cursor: pointer; }
::v-deep .task-expand-clickable .el-table__row:hover > td {
  background: #ecf5ff !important;
}
.debt-val {
  color: #f56c6c;
  font-weight: 700;
  font-size: 14px;
}
.stock-val {
  color: #f56c6c;
  font-weight: 700;
  font-size: 14px;
}
</style>
